// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EMtw","buttons":"styles_buttons__2Ikjz"};